import { render } from "./FaqArticlePage.vue?vue&type=template&id=237d35b0&scoped=true"
import script from "./FaqArticlePage.vue?vue&type=script&lang=js"
export * from "./FaqArticlePage.vue?vue&type=script&lang=js"

import "./FaqArticlePage.vue?vue&type=style&index=0&id=237d35b0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237d35b0"]])

export default __exports__